import { useState } from 'react';
import { Link } from 'react-router-dom';
import { testimonialList } from '@/mocks/series';

export const homeFaqs = [
  {
    q: '吃瓜每日和普通娱乐号有什么区别？',
    a: '普通娱乐号大多是一锤子买卖的一条新闻。我们做的是「连续剧式」追更：把有反转、有后续、成系列的瓜料按第1集、第2集……第N集整理成时间线，方便你回看前因、蹲守后续，不会看到一半就断片。',
  },
  {
    q: '系列里的「第N集」是什么意思？',
    a: '我们把每一个成系列的瓜局当作一部剧来看待，每一次关键进展就是一集。点进某部系列，就能按时间线看到从开播到现在的全部剧情更新与后续进展，翻到哪一集都清楚。',
  },
  {
    q: '如何第一时间看到某部系列的剧情更新？',
    a: '关注你感兴趣的系列后，在该系列页面会清晰标注最新更新的集数与日期。想要更主动的通知，可到「追更大厅」按热度与类型筛选，我们也会在话题热度榜上实时同步最热的进展。',
  },
  {
    q: '站内内容可以转载吗？',
    a: '站内系列剧情均为虚构娱乐内容，仅供娱乐参考。如需转载或合作，欢迎通过页脚的联系方式与我们沟通，理性吃瓜、友善追更。',
  },
];

const principles = [
  '中立梳理，客观呈现每场瓜局的来龙去脉',
  '按集时间线，前因后果可随时回看',
  '热瓜随更，剧情更新与后续进展不缺席',
  '虚构剧情理性吃瓜，只提供娱乐，不评判真人',
];

export default function Proof() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <>
      <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <p className="text-sm font-bold tracking-wide text-primary-600">关于吃瓜每日</p>
            <h2 className="mt-1 font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
              追剧式吃瓜
              <br />
              我们是认真的
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              吃瓜每日是一档专注娱乐吃瓜的连续剧式追更平台。我们相信，真正好吃的瓜不该是一条被淹没在信息流里的热搜，
              而该是一段能让人顺着时间线一路追下去的剧情。于是我们把成系列的瓜料做成栏目，按集追踪剧情更新、后续进展与系列走向，
              让你翻得过瘾、追得不迷路。
            </p>
            <ul className="mt-6 flex flex-col gap-3">
              {principles.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {p}
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-6 inline-flex h-11 items-center whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们更多
              <i className="ri-arrow-right-line ml-1.5"></i>
            </Link>
          </div>

          <div>
            <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
              <i className="ri-chat-heart-line text-primary-500"></i>
              追更人的心里话
            </h3>
            <div className="mt-5 flex flex-col gap-4">
              {testimonialList.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-2xl border border-background-200 bg-background-100/70 p-5"
                >
                  <div className="flex items-center gap-3">
                    <img src={t.avatar} alt={`${t.name} 的头像`} className="h-11 w-11 rounded-full object-cover" />
                    <div>
                      <figcaption className="text-sm font-bold text-foreground-950">{t.name}</figcaption>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                    <span className="ml-auto flex gap-0.5 text-secondary-500">
                      {Array.from({ length: 5 }).map((_, k) => (
                        <i key={k} className="ri-star-fill text-xs"></i>
                      ))}
                    </span>
                  </div>
                  <blockquote className="mt-3 text-sm leading-6 text-foreground-700">“{t.text}”</blockquote>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto w-full px-4 md:px-6">
          <div className="mx-auto w-full max-w-3xl">
            <div className="text-center">
              <p className="text-sm font-bold tracking-wide text-primary-600">你可能想问</p>
              <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-4xl">关于追更的常见问题</h2>
            </div>

            <div className="mt-8 flex flex-col gap-3">
              {homeFaqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? null : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    >
                      <span className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-base transition-transform duration-200 ${
                          open ? 'rotate-45 bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                        }`}
                      >
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                    {open && (
                      <p className="px-5 pb-5 text-sm leading-6 text-foreground-600">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}